import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { isOfficialComponent } from "@next-tsx/parser";
import { convertDataSource } from "./convertDataSource.js";
import { convertComponent } from "../convertComponent.js";
export default function convertModule(mod, state, options) {
  if (mod.usedHelpers.size > 0) {
    var _iterator = _createForOfIteratorHelper(mod.usedHelpers),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var helper = _step.value;
        state.usedHelpers.add(helper);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return {
    sourceModule: mod,
    defaultExport: mod.defaultExport ? {
      raw: mod.defaultExport,
      promise: parseModulePart(mod.defaultExport, mod, state, options)
    } : null,
    namedExports: new Map(_toConsumableArray(mod.namedExports).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        part = _ref2[1];
      return [name, {
        raw: part,
        promise: parseModulePart(part, mod, state, options)
      }];
    })),
    internals: mod.internals.map(function (part) {
      return {
        raw: part,
        promise: parseModulePart(part, mod, state, options)
      };
    })
  };
}
function parseModulePart(_x, _x2, _x3, _x4) {
  return _parseModulePart.apply(this, arguments);
}
function _parseModulePart() {
  _parseModulePart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(part, mod, state, options) {
    var _children, _component$id;
    var context, component, _iterator2, _step2, binding, children, _component$children, view, bricks, _t;
    return _regeneratorRuntime().wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(part.type === "function" || part.type === "context")) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", part);
        case 1:
          context = [];
          component = part.component;
          _iterator2 = _createForOfIteratorHelper(component.bindingMap.values());
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              binding = _step2.value;
              if (binding.kind === "resource") {
                context.push(convertDataSource(binding.resource));
              } else if (binding.kind === "state" || binding.kind === "constant" || binding.kind === "param") {
                context.push({
                  name: binding.id.name,
                  value: binding.initialValue,
                  expose: binding.kind === "param",
                  track: true
                });
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (part.type === "view") {
            view = (_component$children = component.children) === null || _component$children === void 0 ? void 0 : _component$children.find(function (child) {
              return isOfficialComponent(child, "View");
            });
            if (view) {
              children = view.children;
            }
          } else {
            children = component.children;
          }
          if (!((_children = children) !== null && _children !== void 0 && _children.length)) {
            _context.next = 3;
            break;
          }
          _context.next = 2;
          return Promise.all(children.map(function (child) {
            return convertComponent(child, mod, state, options, part.type);
          }));
        case 2:
          _t = _context.sent.flat();
          _context.next = 4;
          break;
        case 3:
          _t = [];
        case 4:
          bricks = _t;
          return _context.abrupt("return", {
            type: part.type,
            bricks: bricks,
            context: context,
            name: (_component$id = component.id) === null || _component$id === void 0 ? void 0 : _component$id.name,
            proxy: component.proxy,
            title: part.title
          });
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _parseModulePart.apply(this, arguments);
}
//# sourceMappingURL=convertModule.js.map